export enum CarbonClearGovEnum {
  None = 0,
  InProgress = 10,
  Registered = 11,
  Ll97Missing = 12,
  Ll97Complete = 13,
}

export enum CarbonClearTestEnum {
  Check = 10,
  Create = 11,
  Update = 12,
}
